module.exports = __webpack_public_path__ + "img/icon-circle-plus.172ac2b6.svg";